@if (badges.length) {
  <section
    class="open-badges">
    <h2 class="open-badges__title">{{ "my_profile.my_open_badges" | translate }}</h2>
    <ul class="open-badges__list">
      @for (badge of badges; track badge) {
        <li
          class="open-badges__card"
          [class.open-badges__card--locked]="!badge?.get('unLocked')"
          [style.background-image]="'url(' + badge?.get('image') + ')'"
          [matTooltip]="badge?.get('name')"
          (click)="onClick(badge)">
          @if (!badge?.get('unLocked')) {
            <mat-icon
              class="open-badges__locked-card-icon"
              svgIcon="lock-rounded-fill">
            </mat-icon>
          }
        </li>
      }
    </ul>
  </section>
}